import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FiRefreshCw } from 'react-icons/fi';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // You could also send this to your error tracking service
    // Example: logErrorToService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 py-12 text-center">
          <div className="max-w-md mx-auto">
            <h1 className="text-4xl font-bold text-red-600">Oops!</h1>
            <h2 className="mt-4 text-2xl font-semibold text-gray-700">Diçka shkoi keq</h2>
            
            <p className="mt-6 text-lg text-gray-600">
              Na vjen keq, por ka ndodhur një gabim i papritur. Ju lutemi rifreskoni faqen ose provoni përsëri më vonë.
            </p>
            
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => window.location.reload()}
                className="flex items-center justify-center gap-2 px-6 py-3 text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
              >
                <FiRefreshCw className="text-lg" />
                <span>Rifresko faqen</span>
              </button>
              
              <Link 
                to="/"
                className="flex items-center justify-center gap-2 px-6 py-3 text-blue-600 border border-blue-600 rounded-md hover:bg-blue-50 transition-colors"
              >
                <span>Kthehu në faqen kryesore</span>
              </Link>
            </div>
            
            {/* Only show technical details in development */}
            {process.env.NODE_ENV === 'development' && (
              <div className="mt-8 p-4 bg-gray-100 rounded-md text-left overflow-auto">
                <h3 className="text-lg font-semibold mb-2">Technical Details:</h3>
                <p className="text-red-600 mb-2">{this.state.error && this.state.error.toString()}</p>
                <p className="text-sm text-gray-700">
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </p>
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 